export const NotificationCategoryEnum = {
  ELECTRIC_AND_WATER_INVOICE: 1,
  MANAGEMENT_SERVICE: 2,
  SEND_EVENT_TO_CUSTOMER: 3,
  NEW_FEEDBACK: 4,
  FEEDBACK_ASSIGN_TO_PROCESSCOR: 5,
  STAFF_COMPLETE_FEEDBACK: 6,
  STAFF_CANCEL_FEEDBACK: 7,
  FEEDBACK_COMPLETE_SEND_TO_CUSTOMER: 8,
  FEEDBACK_CANCEL_SEND_TO_CUSTOMER: 9,
}
// Reference EmailTemplateCategoryEnum
export default NotificationCategoryEnum


// WEBPACK FOOTER //
// ./src/enum/notificationCategoryEnum.js